import React from 'react'
import { useSelector } from 'react-redux'

import { useGetPlan } from '@/app/module/plans/hooks/use-get-plan'
import { selectShowOrgWarning, selectShowTotpWarning, selectUserTOTP } from '@/app/module/user/store/selectors'
import { useShowCanceled } from '@/app/module/user/store/ts/hooks'

import CanceledPlanWarning from './canceled-plan-warning'
import TOTPWarning from './totp-warning'

const OrgWarning: React.FC = () => {
  const { data: plan } = useGetPlan()
  const showOrgTotpWarning = useSelector(selectShowOrgWarning)
  const showTotpWarning = useSelector(selectShowTotpWarning)
  const totpEnabled = useSelector(selectUserTOTP)
  const showCanceledWarning = useShowCanceled()

  if (!plan) {
    return null
  }

  return (
    <>
      {showCanceledWarning && plan.end && <CanceledPlanWarning end={plan.end} />}
      {showTotpWarning && <TOTPWarning showOrgWarning={showOrgTotpWarning} totpEnabled={totpEnabled} />}
    </>
  )
}

export default OrgWarning
